import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { setLastRead } from '../messageThreads/messageThreadSlice'

export const updateLastRead = createAsyncThunk(
  'app/update_last_read',
  async ({ thread_id, message_id, unique_owner_id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.patch('/api/messaging/update_last_read', {
        thread_id,
        message_id,
      })

      const { message_threads } = response?.data || {}

      if (message_threads) dispatch(setLastRead({ thread_id, last_seen_id: message_threads[thread_id].last_seen_id }))
      
      return response?.data
    } catch (err) {
      console.error('Error in updateLastRead thunk:', err)
      return rejectWithValue(err?.response?.data || { error: 'Unexpected error' })
    }
  }
)
